/*
function generateUUID() {
  if (crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function getFunnelId() {
  const funnelData = JSON.parse(localStorage.getItem('funnelData') || "{}");
  const now = Date.now();

  const TIMEOUT = 1000 * 60 * 60 * 24; // 24 hours
  if (!funnelData.id || (now - funnelData.timestamp) > TIMEOUT) {
    const newId = generateUUID();
    localStorage.setItem('funnelData', JSON.stringify({
      id: newId,
      timestamp: now
    }));
    return newId;
  }

  return funnelData.id;
}

export function clearFunnelId() {
  localStorage.removeItem('funnelData');
}*/

export function generateEventId() {
  return generateUUID();
}

// 🔐 Helper: parse URL query parameters
function getQueryParams() {
  const params = {};
  const query = window.location.search.substring(1);
  const pairs = query.split("&");
  for (const pair of pairs) {
    const [key, value] = pair.split("=");
    if (key) params[key] = decodeURIComponent(value || "");
  }
  return params;
}

// 🔐 Helper: generate a UUID (works in browsers)
function generateUUID() {
  return crypto.randomUUID ? crypto.randomUUID() : ([1e7]+-1e3+-4e3+-8e3+-1e11)
    .replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

// 🔐 Main function: initialize or update funnel
export function initializeFunnel() {
  const params = getQueryParams();
  const stored = JSON.parse(localStorage.getItem("funnelData") || "null");

  const now = Date.now();
  const funnelExpirationMs = 1000 * 60 * 60 * 24; // 24 hours

  // ✅ If user clicked a new ad (fbclid or utm changes), start new funnel
  const hasNewAdClick = params.fbclid && (!stored || params.fbclid !== stored.fbclid);

  // ✅ Or funnel expired
  const hasExpired = stored && (now - stored.createdAt > funnelExpirationMs);

  if (hasNewAdClick || hasExpired || !stored) {
    const funnelData = {
      funnelId: generateUUID(),
      fbclid: params.fbclid || null,
      utm_source: params.utm_source || null,
      utm_medium: params.utm_medium || null,
      utm_campaign: params.utm_campaign || null,
      utm_content: params.utm_content || null,
      utm_term: params.utm_term || null,
      createdAt: now
    };

    localStorage.setItem("funnelData", JSON.stringify(funnelData));
    return funnelData;
  }

  return stored;
}

// Retrieve funnel (will initialize if needed)
export function getFunnel() {
  return JSON.parse(localStorage.getItem("funnelData") || "null") || initializeFunnel();
}

// Optional: clear funnel (e.g., after purchase complete)
export function clearFunnel() {
  localStorage.removeItem("funnelData");
}
